angular
  .module('sbsf.enums', [])
  .constant('BATCH_CANCELLATION_AVAILABILITY_CODE', {
    ProgressActionNotSupported: 1,
    BatchNotExist: 2,
    HasChildProcesses: 3,
    CancellationHaveAlreadyBeenRequested: 4,
    Available: 5,
    DoNotHavePermission: 6
  })
  .constant('GDPR_RECORD_VERSION_STATE', {
    SUCCESS: 1,
    PARTIAL: 2,
    FAILURE: 3
  })
  .constant('AUDIT_EVENT_TYPE', {
    ADDED_OBJECT_TYPE_EXCLUSION: 'ADDED_OBJECT_TYPE_EXCLUSION',
    ADMINS_ONLY_CHANGED: 'ADMINS_ONLY_CHANGED',
    ALERT_RULE_ADDED: 'ALERT_RULE_ADDED',
    ALERT_RULE_CHANGED: 'ALERT_RULE_CHANGED',
    ALERT_RULE_DELETED: 'ALERT_RULE_DELETED',
    API_LIMIT_CHANGED: 'API_LIMIT_CHANGED',
    BACKUP_NET_BIND_ORGANIZATION: 'BACKUP_NET_BIND_ORGANIZATION',
    BACKUP_NET_UNBIND_ORGANIZATION: 'BACKUP_NET_UNBIND_ORGANIZATION',
    BACKUP_START_TIME_CHANGED: 'BACKUP_START_TIME_CHANGED',
    BATCH_OUTPUT_DOWNLOADED: 'BATCH_OUTPUT_DOWNLOADED',
    BILLING_INFO_CHANGED: 'BILLING_INFO_CHANGED',
    BULK_API_LIMIT_CHANGED: 'BULK_API_LIMIT_CHANGED',
    CHATTER_NOTIFICATION_SETTINGS_CHANGED: 'CHATTER_NOTIFICATION_SETTINGS_CHANGED',
    DELETED_OBJECT_TYPE_EXCLUSION: 'DELETED_OBJECT_TYPE_EXCLUSION',
    EMAIL_NOTIFICATION_SETTINGS_CHANGED: 'EMAIL_NOTIFICATION_SETTINGS_CHANGED',
    EXTERNAL_USER_LOGGED_IN: 'EXTERNAL_USER_LOGGED_IN',
    EXTERNAL_API_SECRET_GENERATED: 'EXTERNAL_API_SECRET_GENERATED',
    EXTERNAL_API_SECRET_DELETED: 'EXTERNAL_API_SECRET_DELETED',
    IT_COMPLETE_FEATURE_CHANGED: 'IT_COMPLETE_FEATURE_CHANGED',
    IT_COMPLETE_BIND_ORGANIZATION: 'IT_COMPLETE_BIND_ORGANIZATION',
    IT_COMPLETE_UNBIND_ORGANIZATION: 'IT_COMPLETE_UNBIND_ORGANIZATION',
    KMS_ARN_CHANGED: 'KMS_ARN_CHANGED',
    PRIMARY_OBJECTS_CHANGED: 'PRIMARY_OBJECTS_CHANGED',
    RESELLER_MIGRATION: 'RESELLER_MIGRATION',
    SERVICE_ACCOUNT_CHANGED: 'SERVICE_ACCOUNT_CHANGED',
    SUBSCRIPTION_DATES_CHANGED: 'SUBSCRIPTION_DATES_CHANGED',
    SUBSCRIPTION_TYPE_CHANGED: 'SUBSCRIPTION_TYPE_CHANGED',
    USE_KMS_CHANGED: 'USE_KMS_CHANGED',
    USER_PERMISSIONS_CHANGED: 'USER_PERMISSIONS_CHANGED'
  })
  .constant('RESTORE_LOOKUP_RELATIONSHIP_ENUM', {
    NoAction: 0,
    Repair: 1,
    Restore: 2
  })
  .constant('ALERT_RULE_OBJECT_STATE', {
    ADDED: 'added',
    DELETED: 'deleted',
    UPDATED: 'updated'
  })
  .constant('ALERT_RULE_RECORD_TYPE', {
    OBJECT: 'object',
    METADATA: 'metadata'
  })
  .constant('ALERT_RULE_TRIGGER_TYPE', {
    // This trigger type allows us to check for the number of objects backed up to be at least (>=) a specific value.
    AT_LEAST: 'at_least',
    // This trigger type allows us to check for the number of objects backed up to be at most (<=) a specific value.
    AT_MOST: 'at_most',
    // This trigger type allows us to check for decreases in the number of objects backed up from one backup to the next.
    DECREASE: 'decrease',
    // This trigger type allows us to check for increases in the number of objects backed up from one backup to the next.
    INCREASE: 'increase'
  })
  .constant('ALERT_RULE_TRIGGER_VALUE_TYPE', {
    COUNT: 'count',
    PERCENT: 'percent'
  })
  .constant('JOB_TYPE', {
    BULK_RESTORE: 'BULK_RESTORE',
    BULK_RESTORE_CSV_VERIFICATION: 'BULK_RESTORE_CSV_VERIFICATION',
    BULK_RESTORE_PREVIEW: 'BULK_RESTORE_PREVIEW',
    CROSS_ORG_RESTORE: 'CROSS_ORG_RESTORE',
    CUSTOM_TIME_BACKUP: 'CUSTOM_TIME_BACKUP',
    DOWNLOAD_BATCH_OUTPUT: 'DOWNLOAD_BATCH_OUTPUT',
    EXPORT: 'EXPORT',
    MANUAL_BACKUP: 'MANUAL_BACKUP',
    METADATA_COMPARE: 'METADATA_COMPARE',
    METADATA_RESTORE: 'METADATA_RESTORE',
    OBJECT_RESTORE: 'OBJECT_RESTORE',
    SCHEDULED_BACKUP: 'SCHEDULED_BACKUP',
    GDPR_VERIFICATION: 'GDPR_VERIFICATION',
    GDPR_OVERWRITING: 'GDPR_OVERWRITING',
    GDPR_DELETION: 'GDPR_DELETION',
    SEARCH_INDEX: 'SEARCH_INDEX'
  });
